<div [formGroup]="formGroup" class="mb-24">

    <ng-container *ngIf="!isMobile; else channelFormMobileTemp">
        <ng-container *ngIf="!isChild">
            <div class="mat-subtitle-1 title-dark">Channels</div>
            <p class="lblack mat-body-strong mb-16">
                Members must have already chosen a channel in order to receive a message on that channel.
            </p>
        </ng-container>
        
        <mat-card formGroupName="channels" class="p-0" [ngClass]="{ 'mat-elevation-z0': isChild }">
            <div class="channel top d-flex justify-content-between h-50 align-items-center">
                <span class="mat-subtitle-2">SMS</span>
                <mat-slide-toggle formControlName="sms"></mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>
            <div class="channel d-flex justify-content-between h-50 align-items-center">
                <span class="mat-subtitle-2">Voice Call</span>
                <mat-slide-toggle formControlName="voice"></mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>
            <div class="channel bottom d-flex justify-content-between h-50 align-items-center">
                <span class="mat-subtitle-2">E-Mail</span>
                <mat-slide-toggle formControlName="email"></mat-slide-toggle>
            </div>
        </mat-card>
    </ng-container>

    <ng-template #channelFormMobileTemp>
        <div [formGroup]="formGroup">
            <mat-card appearance="outlined" formGroupName="channels" class="p-0 mat-elevation-z0 bh-border">
                <div class="channel top d-flex justify-content-between h-50 align-items-center">
                    <span class="mat-subtitle-2">SMS</span>
                    <mat-checkbox formControlName="sms"></mat-checkbox>
                </div>
                <mat-divider style="display: block !important;"></mat-divider>
                <div class="channel d-flex justify-content-between h-50 align-items-center">
                    <span class="mat-subtitle-2">Voice Call</span>
                    <mat-checkbox formControlName="voice"></mat-checkbox>
                </div>
                <mat-divider style="display: block !important;"></mat-divider>
                <div class="channel bottom d-flex justify-content-between h-50 align-items-center">
                    <span class="mat-subtitle-2">E-Mail</span>
                    <mat-checkbox formControlName="email"></mat-checkbox>
                </div>
            </mat-card>
        </div>
    </ng-template>
</div>
